import { NavMenu } from "@lvt/vertical-navbar";
import { Box, Divider, Link } from "@material-ui/core";
import { HelpOutline } from "@material-ui/icons";

import { supportEmail, supportHours, supportPhone, supportVMSBetaGuide } from "@/utilities/support";

import useStyles from "./HelpCenter.styles";


const HelpCenter = () => {
    const classes = useStyles();

    return (
        <NavMenu
            icon={<HelpOutline />}
            label="Help Center"
            menuClassName={classes.menu}
        >
            <div className={classes.menuSection}>
                <div className={classes.menuHeader}>Get Help</div>
            </div>
            <div className={classes.menuSection}>
                <Box className={classes.sectionHeader}>Knowledge Base</Box>
                <Link
                    href={supportVMSBetaGuide}
                    target="_blank"
                    underline="none"
                    color="secondary"
                >
                    Support Center
                </Link>
            </div>
            <Divider className={classes.divider} />
            <div className={classes.menuSection}>
                <div className={classes.sectionHeader}>Contact Support</div>
                <Box display="flex">
                    <Box display="flex" flexDirection="column" fontWeight="fontWeightBold">
                        <div>Email:</div>
                        <div>Phone:</div>
                        <div>Hours:</div>
                    </Box>
                    <Box display="flex" flexDirection="column" marginLeft="1em">
                        <div>
                            <Link
                                href={`mailto:${supportEmail}`}
                                target="_blank"
                                color="secondary"
                                variant="inherit"
                            >
                                {supportEmail}
                            </Link>
                        </div>
                        <div>{supportPhone}</div>
                        <div>{supportHours}</div>
                    </Box>
                </Box>
            </div>
        </NavMenu>
    );
};

export default HelpCenter;
